/* eslint-disable no-unused-vars */
import Grid from "@mui/material/Grid";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRight";
import NotListedLocationOutlinedIcon from "@mui/icons-material/NotListedLocationOutlined";
import PDialog from "./PDialog";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, IconButton } from "@mui/material";
//import PrintingUtils from "../../utils/PrintingUtils";
import CloseIcon from "@mui/icons-material/Close";

export default function PFileViewer(props) {
  const [open, setOpen] = React.useState(true);

  const { t } = useTranslation();
  const translate = t;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [countOfFiles, setCountOfFiles] = useState(0);
  const [selectedPreviewFile, setSelectedPreviewFile] = useState(null);
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
  const [isPrintLoaderEnabled, setIsPrintLoaderEnabled] = useState(false);

  useEffect(() => {}, [props.openWindow]);

  useEffect(() => {
    if (props.filesList) {
      setCountOfFiles(props.filesList.length);
      let index = 0;
      props.filesList.map((item) => {
        if (item.selected) {
          setCurrentIndex(index);
          setSelectedPreviewFile(item);
          if (item.showAgent) {
            setOpen(true);
          } else {
            setOpen(false);
          }
        }
        index = index + 1;
      });
    }
  }, [props.filesList]);

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  function onBackwordClick() {
    let newIndex = currentIndex - 1;
    if (newIndex >= 0) {
      setCurrentIndex(newIndex);
      setSelectedPreviewFile(props.filesList[newIndex]);
    } else {
      setCurrentIndex(0);
      if (props.showMessage) props.showMessage("error", "Reached end");
    }
  }

  function onForwordClick() {
    let newIndex = currentIndex + 1;
    if (newIndex < countOfFiles) {
      setCurrentIndex(newIndex);
      setSelectedPreviewFile(props.filesList[newIndex]);
    } else {
      setCurrentIndex(countOfFiles - 1);
      if (props.showMessage) props.showMessage("error", "Reached end");
    }
  }

  function handlePrintClick() {
    if (selectedPreviewFile) {
      let payload = {};
      //TODO JOSE
      //payload["file"] = fileData;
      //payload["fileType"] = fileType;
      /*PrintingUtils.print(
        printingMode,
        "targetPrinter", //TODO
        null,
        payload,
        props.setAlert,
        null,
        translate,
        null,
        null,
        null
      );*/
    } else props.showMessage("error", "No file found for print");
  }

  const content = (
    <div>
      {selectedPreviewFile && selectedPreviewFile.fileType == "IMAGE" && (
        <Grid container alignItems="center" justify="center">
          <Grid item xs="auto">
            <img
              src={selectedPreviewFile.previewObj}
              style={{ width: "100%", height: "100%" }}
              alt=""
            />
          </Grid>
        </Grid>
      )}
      {selectedPreviewFile && selectedPreviewFile.fileType == "DOCUMENT" && (
        <Grid container>
          {selectedPreviewFile.showAgent && open && (
            <Grid item xs={12}>
              <Alert
                severity="info"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                You can Install an Agent for direct printing , Please contact
                support for getting it installed
              </Alert>
            </Grid>
          )}
          <Grid item xs={12}>
            <object
              style={{
                width: "100%",
                height: "600px",
              }}
              data={selectedPreviewFile.previewObj}
            />
          </Grid>
        </Grid>
      )}
      {!selectedPreviewFile && (
        <Grid container alignItems="center" justify="center">
          <Grid item xs="auto">
            <NotListedLocationOutlinedIcon
              style={{
                width: "100%",
                height: "100%",
                color: "#c9c5c5",
              }}
            />
          </Grid>
        </Grid>
      )}
      <Grid container direction="column" alignItems="center" justify="center">
        <Grid item xs={4}>
          <table width="100%">
            <tr>
              <td>
                <ChevronLeftOutlinedIcon
                  style={{
                    width: "30px",
                    height: "30px",
                    color: currentIndex - 1 < 0 ? "#c9c5c5" : "#000000",
                  }}
                  onClick={() => onBackwordClick()}
                />
              </td>
              <td>
                {(countOfFiles > 0 ? currentIndex + 1 : 0) +
                  " of " +
                  countOfFiles}
              </td>
              <td>
                <ChevronRightOutlinedIcon
                  style={{
                    width: "30px",
                    height: "30px",
                    color:
                      currentIndex + 1 < countOfFiles ? "#000000" : "#c9c5c5",
                  }}
                  onClick={() => onForwordClick()}
                />
              </td>
            </tr>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      {props.openWindow && (
        <PDialog
          content={content}
          title={translate("File Viewer")}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={handlePrintClick}
          saveLabel={"Print"}
          isSaveLoaderEnabled={isPrintLoaderEnabled}
          mode={"create"}
          isLoaderEnabled={isLoaderEnabled}
          hideSave={props.disableDefaultPrint}
        ></PDialog>
      )}
    </div>
  );
}
